<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">見積システム</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_QS_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn
          :disabled="selected.length == 0"
          @click="remove"
          v-permit.SHARP_QS_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >
        <v-btn to="/B0201/new" v-permit.SHARP_QS_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length != 1"
          @click="edit"
          v-permit.SHARP_QS_EDIT
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn @click="exportCsv" v-permit.SHARP_QS_DOWNLOAD>{{
          $t('app.buttons.csvExport')
        }}</v-btn>
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <v-text-field
                clearable
                label="見積NO"
                v-model="query.quotationNo"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                url="ports/kv"
                v-model="query.loadingPortCode"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kv?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-select
                :label="$t('app.labels.transportMode')"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-select
                label="コンテナ情報"
                url="container-types/kv"
                v-model="query.containerTypeId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="納入場所"
                url="warehouses/kv"
                v-model="query.finallyWarehouseId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-select
                :label="$t('app.labels.incoterm')"
                item-text="code"
                url="incoterms/kv"
                v-model="query.incotermId"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="依頼者"
                url="employees/kv"
                v-model="query.requestById"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.headquarterId"
              />
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    label="納入予定日"
                    v-model="query.forecastDeliveryDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.forecastDeliveryDateFrom"
                    label
                    v-model="query.forecastDeliveryDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    label="作成日"
                    v-model="query.createTimeStart"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker
                    :min="query.createTimeStart"
                    label="~"
                    v-model="query.createTimeEnd"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="results">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="results"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="elevation-0"
            item-key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>{{ props.item.quotationNo }}</td>
              <td>
                {{ props.item.loadingPortCode }}&nbsp;{{
                  props.item.loadingPortName
                }}
              </td>
              <td>
                {{ props.item.dischargePortCode }}&nbsp;{{
                  props.item.dischargePortName
                }}
              </td>
              <td>
                {{ props.item.finallyWarehouseCode }}&nbsp;{{
                  props.item.finallyWarehouseName
                }}
              </td>
              <td>
                {{ props.item.partnerCode }}&nbsp;{{ props.item.partnerName }}
              </td>
              <td>{{ props.item.incotermCode }}</td>
              <td>{{ props.item.transportModeCode }}</td>
              <!-- <td>{{props.item.transportMethodCode}}</td> -->
              <td>{{ props.item.containerTypeName }}</td>
              <!-- <td>{{props.item.truckTypeCode}}</td> -->
              <td>
                {{ importCost(props.item) | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{ estimatePrice(props.item) | currency({ fractionCount: 0 }) }}
              </td>
              <td>
                {{
                  (props.item.paidType === '無償'
                    ? 0
                    : staticsOfSkuPrice(props.item))
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('海上航空運賃', props.item)
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('国内運賃', props.item)
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('保険費', props.item) | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('搬出手数料', props.item)
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('CC.FEE', props.item) | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('取扱料', props.item) | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('通関料', props.item) | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('デバン料', props.item)
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('その他費用１', props.item)
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('その他費用２', props.item)
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>
                {{
                  statics('SJL Commission', props.item)
                    | currency({ fractionCount: 0 })
                }}
              </td>
              <td>{{ props.item.creator }}</td>
              <td>{{ props.item.updater }}</td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {},
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    importCost(quotation) {
      return (
        quotation.summaryCharges &&
        Object.keys(quotation.summaryCharges)
          .filter(
            (k) =>
              !(quotation.paidType === '無償' && '商品代金'.indexOf(k) !== -1)
          )
          .reduce((t, k) => t + quotation.summaryCharges[k], 0)
      )
    },
    estimatePrice(quotation) {
      return (
        quotation.summaryCharges &&
        Object.keys(quotation.summaryCharges)
          .filter((k) => '商品代金,保険費'.indexOf(k) === -1)
          .reduce((t, k) => t + quotation.summaryCharges[k], 0)
      )
    },
    displayItems(quotation) {
      return quotation.summaryCharges || []
    },
    statics(type, shipment) {
      return shipment.summaryCharges && shipment.summaryCharges[type]
    },
    staticsOfSkuPrice(shipment) {
      return this.statics('商品代金', shipment)
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('/quotations', this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    search() {
      this.pagination.page = 0
      this.load()
    },
    remove() {
      this.$confirm({
        content: this.$t('app.messages.removeConfirm'),
      }).then(() => {
        Promise.all(
          this.selected.map((i) => {
            return this.$http.delete(`/quotations/${i.id}`).catch()
          })
        ).then(() => {
          this.selected = []
          this.load()
        })
        this.$message('', '削除成功')
      })
    },
    edit() {
      this.$router.push({
        path: '/B0201/edit',
        query: {
          id: this.selected[0].id,
        },
      })
    },
    exportCsv() {
      let params = this.params()
      params.size = 100000
      this.$http.get('/quotations', params).then((res) => {
        let result = res.data.content.map((r) => {
          return {
            ...r,
            importCost: this.importCost(r),
            estimatePrice: this.estimatePrice(r),
            staticsOfSkuPrice: this.staticsOfSkuPrice(r),
            statics1: this.statics('海上航空運賃', r),
            statics2: this.statics('国内運賃', r),
            statics3: this.statics('保険費', r),
            statics4: this.statics('搬出手数料', r),
            statics5: this.statics('CC.FEE', r),
            statics6: this.statics('取扱料', r),
            statics7: this.statics('通関料', r),
            statics8: this.statics('デバン料', r),
            statics9: this.statics('その他費用１', r),
            statics10: this.statics('その他費用２', r),
            statics11: this.statics('SJL Commission', r),
          }
        })
        let headers = [
          '見積 NO',
          '積出港CD',
          '積出港',
          '陸揚港CD',
          '陸揚港',
          '納入場所CD',
          '納入場所',
          '海外取引先CD',
          '海外取引先',
          '建値',
          '輸送形態',
          'コンテナ情報',
          '輸入コスト',
          '概算見積',
          '商品代金',
          '海上航空運賃',
          '国内運賃',
          '保険費',
          '搬出手数料',
          'CC FEE',
          '取扱料',
          '通関料',
          'デバン料',
          'その他費用１',
          'その他費用２',
          'SJL Commission',
          '作成者',
          '更新者',
        ]
        let cols = [
          'quotationNo',
          'loadingPortCode',
          'loadingPortName',
          'dischargePortCode',
          'dischargePortName',
          'finallyWarehouseCode',
          'finallyWarehouseName',
          'partnerCode',
          'partnerName',
          'incotermCode',
          'transportModeCode',
          'containerTypeName',
          'importCost',
          'estimatePrice',
          'staticsOfSkuPrice',
          'statics1',
          'statics2',
          'statics3',
          'statics4',
          'statics5',
          'statics6',
          'statics7',
          'statics8',
          'statics9',
          'statics10',
          'statics11',
          'etd',
          'eta',
        ]
        this.$exportTable(result, cols, headers, '見積システムCSV出力')
      })
    },
  },
  mounted() {
    this.$loadParams()
    //this.load()
  },
  data: () => ({
    pagination: {
      rowsPerPage: 10,
    },
    selected: [],
    loading: false,
    results: [],
    query: {},
    headers: [
      {
        text: '見積 NO',
        value: 'quotationNo',
        sortable: false,
        class: 'fixed',
      },
      {
        text: '積出港',
        value: 'loadingPortCode',
        sortable: false,
        class: 'fixed',
      },
      {
        text: '陸揚港',
        value: 'dischargePortCode',
        sortable: false,
        class: 'fixed',
      },
      {
        text: '納入場所',
        value: 'finallyWarehouseCode',
        sortable: false,
        class: 'fixed',
      },
      {
        text: '海外取引先',
        value: 'partnerCode',
        sortable: false,
      },
      {
        text: '建値',
        value: 'incotermCode',
        sortable: false,
      },
      {
        text: '輸送形態',
        value: 'transportModeCode',
        sortable: false,
      },
      // { text: "輸送方法", value: "transportMethod" ,sortable:false},
      {
        text: 'コンテナ情報',
        value: 'containerTypeName',
        sortable: false,
      },
      // { text: "ﾁｬｰﾀｰﾄﾗｯｸ種別", value: "foreignPartner" ,sortable:false},
      {
        text: '輸入コスト',
        value: 'importCost',
        sortable: false,
      },
      {
        text: '概算見積',
        value: 'estimatePrice',
        sortable: false,
      },
      {
        text: '商品代金',
        value: 'staticsOfSkuPrice',
        sortable: false,
      },
      {
        text: '海上航空運賃',
        value: 'statics1',
        sortable: false,
      },
      {
        text: '国内運賃',
        value: 'statics2',
        sortable: false,
      },
      {
        text: '保険費',
        value: 'statics3',
        sortable: false,
      },
      {
        text: '搬出手数料',
        value: 'statics4',
        sortable: false,
      },
      {
        text: 'CC FEE',
        value: 'statics5',
        sortable: false,
      },
      {
        text: '取扱料',
        value: 'statics6',
        sortable: false,
      },
      {
        text: '通関料',
        value: 'statics7',
        sortable: false,
      },
      {
        text: 'デバン料',
        value: 'statics8',
        sortable: false,
      },
      {
        text: 'その他費用１',
        value: 'statics9',
        sortable: false,
      },
      {
        text: 'その他費用２',
        value: 'statics10',
        sortable: false,
      },
      {
        text: 'SJL Commission',
        value: 'statics11',
        sortable: false,
      },
      {
        text: '作成者',
        value: 'createBy',
        sortable: false,
      },
      {
        text: '更新者',
        value: 'updateBy',
        sortable: false,
      },
    ],
  }),
}
</script>
